export default __webpack_public_path__ + "static/media/login.52fd2fae.png";